import Products from 'merchandise-lib/constants/Product';
import { HC_0136_SALES_HUB_PROFESSIONAL, HC_0136_SERVICE_HUB_PROFESSIONAL } from 'pricing-pages-ui-components/constants/PromotionKeys';
import { useSelector } from 'react-redux';
import { ANNUAL } from 'self-service-api/constants/Terms';
import { useGetEnrolledPromotionsByPortalIdQuery } from '../../__generated__/chirp/com/hubspot/fintech/discounts/rpc/PromotionsRpc.hooks';
import { isAppAuthSelector } from '../selectors/AuthSelectors';
import { SCREENS } from '../v2/constants/tracking/Screens';
import { usePurchaseableProductsForTerm } from './useBulkPurchaseOptions';
export const useTrialDiscountPromotion = ({
  screen
}) => {
  var _data$portalEnrollmen;
  const isAppAuth = useSelector(isAppAuthSelector);
  const screenConfig = {
    [SCREENS.SALES]: {
      apiName: Products.SALES_HUB_PROFESSIONAL,
      promotionId: HC_0136_SALES_HUB_PROFESSIONAL
    },
    [SCREENS.SERVICE]: {
      apiName: Products.SERVICE_HUB_PROFESSIONAL,
      promotionId: HC_0136_SERVICE_HUB_PROFESSIONAL
    }
  };
  const currentConfig = screenConfig[screen];
  const {
    purchaseOptionsForTerm,
    loading,
    error
  } = usePurchaseableProductsForTerm({
    apiName: currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.apiName,
    queryParamTerm: ANNUAL
  });
  const {
    data,
    loading: promoLoading,
    error: promoError
  } = useGetEnrolledPromotionsByPortalIdQuery({
    skip: !isAppAuth
  });
  const foundEnrollment = data === null || data === void 0 || (_data$portalEnrollmen = data.portalEnrollments) === null || _data$portalEnrollmen === void 0 ? void 0 : _data$portalEnrollmen.find(enrollment => (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.promotionId) === enrollment.promotionId);
  const eligibleForPromotion = (foundEnrollment === null || foundEnrollment === void 0 ? void 0 : foundEnrollment.expirationDate) && (foundEnrollment === null || foundEnrollment === void 0 ? void 0 : foundEnrollment.expirationDate) > Date.now();
  const listPrice = Number((purchaseOptionsForTerm === null || purchaseOptionsForTerm === void 0 ? void 0 : purchaseOptionsForTerm.listPrice.monthlyPrice) || 0);
  const discountedPrice = Number((purchaseOptionsForTerm === null || purchaseOptionsForTerm === void 0 ? void 0 : purchaseOptionsForTerm.discountedPrice.monthlyPrice) || 0);
  const discountPercentage = listPrice > 0 ? Math.round((listPrice - discountedPrice) / listPrice * 100) : 0;
  const shouldShowBanner = isAppAuth && !loading && !error && !promoError && !promoLoading && !!eligibleForPromotion && discountPercentage > 0;
  return {
    shouldShowBanner,
    error,
    listPrice,
    discountedPrice,
    discountPercentage,
    expirationDate: foundEnrollment === null || foundEnrollment === void 0 ? void 0 : foundEnrollment.expirationDate,
    promotionId: currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.promotionId,
    apiName: currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.apiName
  };
};